/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './../routes/__root'
import { Route as AuthImport } from './../routes/auth'
import { Route as MainLayoutImport } from './../routes/_mainLayout'
import { Route as AuthIndexImport } from './../routes/auth/index'
import { Route as MainLayoutIndexImport } from './../routes/_mainLayout/index'
import { Route as AuthSignInImport } from './../routes/auth/sign-in'
import { Route as MainLayoutProfileImport } from './../routes/_mainLayout/profile'
import { Route as MainLayoutWalletIndexImport } from './../routes/_mainLayout/wallet/index'
import { Route as MainLayoutProfileIndexImport } from './../routes/_mainLayout/profile/index'
import { Route as MainLayoutInvestIndexImport } from './../routes/_mainLayout/invest/index'
import { Route as MainLayoutCurrentmonthIndexImport } from './../routes/_mainLayout/current_month/index'
import { Route as MainLayoutClaimIndexImport } from './../routes/_mainLayout/claim/index'
import { Route as MainLayoutBuyIndexImport } from './../routes/_mainLayout/buy/index'
import { Route as MainLayoutBalanceIndexImport } from './../routes/_mainLayout/balance/index'
import { Route as MainLayoutWalletWithdrawIndexImport } from './../routes/_mainLayout/wallet/withdraw/index'
import { Route as MainLayoutWalletWaitIndexImport } from './../routes/_mainLayout/wallet/wait/index'
import { Route as MainLayoutWalletTransactionSuccessIndexImport } from './../routes/_mainLayout/wallet/transaction-success/index'
import { Route as MainLayoutWalletTransactionErrorIndexImport } from './../routes/_mainLayout/wallet/transaction-error/index'
import { Route as MainLayoutWalletSwapIndexImport } from './../routes/_mainLayout/wallet/swap/index'
import { Route as MainLayoutWalletPaymentProcessIndexImport } from './../routes/_mainLayout/wallet/payment-process/index'
import { Route as MainLayoutWalletDepositIndexImport } from './../routes/_mainLayout/wallet/deposit/index'
import { Route as MainLayoutProfileSafetyIndexImport } from './../routes/_mainLayout/profile/safety/index'
import { Route as MainLayoutProfileReferralIndexImport } from './../routes/_mainLayout/profile/referral/index'
import { Route as MainLayoutProfileQuestIndexImport } from './../routes/_mainLayout/profile/quest/index'
import { Route as MainLayoutProfileNotificationIndexImport } from './../routes/_mainLayout/profile/notification/index'
import { Route as MainLayoutProfileMobileMenuIndexImport } from './../routes/_mainLayout/profile/mobileMenu/index'
import { Route as MainLayoutProfileAccountIndexImport } from './../routes/_mainLayout/profile/account/index'
import { Route as MainLayoutWalletWaitDepositIndexImport } from './../routes/_mainLayout/wallet/wait/deposit/index'
import { Route as MainLayoutWalletSwapWaitIndexImport } from './../routes/_mainLayout/wallet/swap/wait/index'
import { Route as MainLayoutWalletSwapDepositIdmKeyIndexImport } from './../routes/_mainLayout/wallet/swap/deposit/$idmKey/index'
import { Route as MainLayoutInvestStatsCodeYearMonthIndexImport } from './../routes/_mainLayout/investStats/$code/$year/$month/index'
import { Route as MainLayoutInvestCodeYearMonthIndexImport } from './../routes/_mainLayout/invest/$code/$year/$month/index'

// Create/Update Routes

const AuthRoute = AuthImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const MainLayoutRoute = MainLayoutImport.update({
  id: '/_mainLayout',
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)

const MainLayoutIndexRoute = MainLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const AuthSignInRoute = AuthSignInImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)

const MainLayoutProfileRoute = MainLayoutProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutWalletIndexRoute = MainLayoutWalletIndexImport.update({
  id: '/wallet/',
  path: '/wallet/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutProfileIndexRoute = MainLayoutProfileIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainLayoutProfileRoute,
} as any)

const MainLayoutInvestIndexRoute = MainLayoutInvestIndexImport.update({
  id: '/invest/',
  path: '/invest/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutCurrentmonthIndexRoute =
  MainLayoutCurrentmonthIndexImport.update({
    id: '/current_month/',
    path: '/current_month/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutClaimIndexRoute = MainLayoutClaimIndexImport.update({
  id: '/claim/',
  path: '/claim/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutBuyIndexRoute = MainLayoutBuyIndexImport.update({
  id: '/buy/',
  path: '/buy/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutBalanceIndexRoute = MainLayoutBalanceIndexImport.update({
  id: '/balance/',
  path: '/balance/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutWalletWithdrawIndexRoute =
  MainLayoutWalletWithdrawIndexImport.update({
    id: '/wallet/withdraw/',
    path: '/wallet/withdraw/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletWaitIndexRoute = MainLayoutWalletWaitIndexImport.update({
  id: '/wallet/wait/',
  path: '/wallet/wait/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutWalletTransactionSuccessIndexRoute =
  MainLayoutWalletTransactionSuccessIndexImport.update({
    id: '/wallet/transaction-success/',
    path: '/wallet/transaction-success/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletTransactionErrorIndexRoute =
  MainLayoutWalletTransactionErrorIndexImport.update({
    id: '/wallet/transaction-error/',
    path: '/wallet/transaction-error/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletSwapIndexRoute = MainLayoutWalletSwapIndexImport.update({
  id: '/wallet/swap/',
  path: '/wallet/swap/',
  getParentRoute: () => MainLayoutRoute,
} as any)

const MainLayoutWalletPaymentProcessIndexRoute =
  MainLayoutWalletPaymentProcessIndexImport.update({
    id: '/wallet/payment-process/',
    path: '/wallet/payment-process/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletDepositIndexRoute =
  MainLayoutWalletDepositIndexImport.update({
    id: '/wallet/deposit/',
    path: '/wallet/deposit/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutProfileSafetyIndexRoute =
  MainLayoutProfileSafetyIndexImport.update({
    id: '/safety/',
    path: '/safety/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileReferralIndexRoute =
  MainLayoutProfileReferralIndexImport.update({
    id: '/referral/',
    path: '/referral/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileQuestIndexRoute =
  MainLayoutProfileQuestIndexImport.update({
    id: '/quest/',
    path: '/quest/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileNotificationIndexRoute =
  MainLayoutProfileNotificationIndexImport.update({
    id: '/notification/',
    path: '/notification/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileMobileMenuIndexRoute =
  MainLayoutProfileMobileMenuIndexImport.update({
    id: '/mobileMenu/',
    path: '/mobileMenu/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutProfileAccountIndexRoute =
  MainLayoutProfileAccountIndexImport.update({
    id: '/account/',
    path: '/account/',
    getParentRoute: () => MainLayoutProfileRoute,
  } as any)

const MainLayoutWalletWaitDepositIndexRoute =
  MainLayoutWalletWaitDepositIndexImport.update({
    id: '/wallet/wait/deposit/',
    path: '/wallet/wait/deposit/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletSwapWaitIndexRoute =
  MainLayoutWalletSwapWaitIndexImport.update({
    id: '/wallet/swap/wait/',
    path: '/wallet/swap/wait/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutWalletSwapDepositIdmKeyIndexRoute =
  MainLayoutWalletSwapDepositIdmKeyIndexImport.update({
    id: '/wallet/swap/deposit/$idmKey/',
    path: '/wallet/swap/deposit/$idmKey/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutInvestStatsCodeYearMonthIndexRoute =
  MainLayoutInvestStatsCodeYearMonthIndexImport.update({
    id: '/investStats/$code/$year/$month/',
    path: '/investStats/$code/$year/$month/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

const MainLayoutInvestCodeYearMonthIndexRoute =
  MainLayoutInvestCodeYearMonthIndexImport.update({
    id: '/invest/$code/$year/$month/',
    path: '/invest/$code/$year/$month/',
    getParentRoute: () => MainLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_mainLayout': {
      id: '/_mainLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainLayoutImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_mainLayout/profile': {
      id: '/_mainLayout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MainLayoutProfileImport
      parentRoute: typeof MainLayoutImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInImport
      parentRoute: typeof AuthImport
    }
    '/_mainLayout/': {
      id: '/_mainLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainLayoutIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthImport
    }
    '/_mainLayout/balance/': {
      id: '/_mainLayout/balance/'
      path: '/balance'
      fullPath: '/balance'
      preLoaderRoute: typeof MainLayoutBalanceIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/buy/': {
      id: '/_mainLayout/buy/'
      path: '/buy'
      fullPath: '/buy'
      preLoaderRoute: typeof MainLayoutBuyIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/claim/': {
      id: '/_mainLayout/claim/'
      path: '/claim'
      fullPath: '/claim'
      preLoaderRoute: typeof MainLayoutClaimIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/current_month/': {
      id: '/_mainLayout/current_month/'
      path: '/current_month'
      fullPath: '/current_month'
      preLoaderRoute: typeof MainLayoutCurrentmonthIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/invest/': {
      id: '/_mainLayout/invest/'
      path: '/invest'
      fullPath: '/invest'
      preLoaderRoute: typeof MainLayoutInvestIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/profile/': {
      id: '/_mainLayout/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof MainLayoutProfileIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/wallet/': {
      id: '/_mainLayout/wallet/'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof MainLayoutWalletIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/profile/account/': {
      id: '/_mainLayout/profile/account/'
      path: '/account'
      fullPath: '/profile/account'
      preLoaderRoute: typeof MainLayoutProfileAccountIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/mobileMenu/': {
      id: '/_mainLayout/profile/mobileMenu/'
      path: '/mobileMenu'
      fullPath: '/profile/mobileMenu'
      preLoaderRoute: typeof MainLayoutProfileMobileMenuIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/notification/': {
      id: '/_mainLayout/profile/notification/'
      path: '/notification'
      fullPath: '/profile/notification'
      preLoaderRoute: typeof MainLayoutProfileNotificationIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/quest/': {
      id: '/_mainLayout/profile/quest/'
      path: '/quest'
      fullPath: '/profile/quest'
      preLoaderRoute: typeof MainLayoutProfileQuestIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/referral/': {
      id: '/_mainLayout/profile/referral/'
      path: '/referral'
      fullPath: '/profile/referral'
      preLoaderRoute: typeof MainLayoutProfileReferralIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/profile/safety/': {
      id: '/_mainLayout/profile/safety/'
      path: '/safety'
      fullPath: '/profile/safety'
      preLoaderRoute: typeof MainLayoutProfileSafetyIndexImport
      parentRoute: typeof MainLayoutProfileImport
    }
    '/_mainLayout/wallet/deposit/': {
      id: '/_mainLayout/wallet/deposit/'
      path: '/wallet/deposit'
      fullPath: '/wallet/deposit'
      preLoaderRoute: typeof MainLayoutWalletDepositIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/payment-process/': {
      id: '/_mainLayout/wallet/payment-process/'
      path: '/wallet/payment-process'
      fullPath: '/wallet/payment-process'
      preLoaderRoute: typeof MainLayoutWalletPaymentProcessIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/swap/': {
      id: '/_mainLayout/wallet/swap/'
      path: '/wallet/swap'
      fullPath: '/wallet/swap'
      preLoaderRoute: typeof MainLayoutWalletSwapIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/transaction-error/': {
      id: '/_mainLayout/wallet/transaction-error/'
      path: '/wallet/transaction-error'
      fullPath: '/wallet/transaction-error'
      preLoaderRoute: typeof MainLayoutWalletTransactionErrorIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/transaction-success/': {
      id: '/_mainLayout/wallet/transaction-success/'
      path: '/wallet/transaction-success'
      fullPath: '/wallet/transaction-success'
      preLoaderRoute: typeof MainLayoutWalletTransactionSuccessIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/wait/': {
      id: '/_mainLayout/wallet/wait/'
      path: '/wallet/wait'
      fullPath: '/wallet/wait'
      preLoaderRoute: typeof MainLayoutWalletWaitIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/withdraw/': {
      id: '/_mainLayout/wallet/withdraw/'
      path: '/wallet/withdraw'
      fullPath: '/wallet/withdraw'
      preLoaderRoute: typeof MainLayoutWalletWithdrawIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/swap/wait/': {
      id: '/_mainLayout/wallet/swap/wait/'
      path: '/wallet/swap/wait'
      fullPath: '/wallet/swap/wait'
      preLoaderRoute: typeof MainLayoutWalletSwapWaitIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/wait/deposit/': {
      id: '/_mainLayout/wallet/wait/deposit/'
      path: '/wallet/wait/deposit'
      fullPath: '/wallet/wait/deposit'
      preLoaderRoute: typeof MainLayoutWalletWaitDepositIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/invest/$code/$year/$month/': {
      id: '/_mainLayout/invest/$code/$year/$month/'
      path: '/invest/$code/$year/$month'
      fullPath: '/invest/$code/$year/$month'
      preLoaderRoute: typeof MainLayoutInvestCodeYearMonthIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/investStats/$code/$year/$month/': {
      id: '/_mainLayout/investStats/$code/$year/$month/'
      path: '/investStats/$code/$year/$month'
      fullPath: '/investStats/$code/$year/$month'
      preLoaderRoute: typeof MainLayoutInvestStatsCodeYearMonthIndexImport
      parentRoute: typeof MainLayoutImport
    }
    '/_mainLayout/wallet/swap/deposit/$idmKey/': {
      id: '/_mainLayout/wallet/swap/deposit/$idmKey/'
      path: '/wallet/swap/deposit/$idmKey'
      fullPath: '/wallet/swap/deposit/$idmKey'
      preLoaderRoute: typeof MainLayoutWalletSwapDepositIdmKeyIndexImport
      parentRoute: typeof MainLayoutImport
    }
  }
}

// Create and export the route tree

interface MainLayoutProfileRouteChildren {
  MainLayoutProfileIndexRoute: typeof MainLayoutProfileIndexRoute
  MainLayoutProfileAccountIndexRoute: typeof MainLayoutProfileAccountIndexRoute
  MainLayoutProfileMobileMenuIndexRoute: typeof MainLayoutProfileMobileMenuIndexRoute
  MainLayoutProfileNotificationIndexRoute: typeof MainLayoutProfileNotificationIndexRoute
  MainLayoutProfileQuestIndexRoute: typeof MainLayoutProfileQuestIndexRoute
  MainLayoutProfileReferralIndexRoute: typeof MainLayoutProfileReferralIndexRoute
  MainLayoutProfileSafetyIndexRoute: typeof MainLayoutProfileSafetyIndexRoute
}

const MainLayoutProfileRouteChildren: MainLayoutProfileRouteChildren = {
  MainLayoutProfileIndexRoute: MainLayoutProfileIndexRoute,
  MainLayoutProfileAccountIndexRoute: MainLayoutProfileAccountIndexRoute,
  MainLayoutProfileMobileMenuIndexRoute: MainLayoutProfileMobileMenuIndexRoute,
  MainLayoutProfileNotificationIndexRoute:
    MainLayoutProfileNotificationIndexRoute,
  MainLayoutProfileQuestIndexRoute: MainLayoutProfileQuestIndexRoute,
  MainLayoutProfileReferralIndexRoute: MainLayoutProfileReferralIndexRoute,
  MainLayoutProfileSafetyIndexRoute: MainLayoutProfileSafetyIndexRoute,
}

const MainLayoutProfileRouteWithChildren =
  MainLayoutProfileRoute._addFileChildren(MainLayoutProfileRouteChildren)

interface MainLayoutRouteChildren {
  MainLayoutProfileRoute: typeof MainLayoutProfileRouteWithChildren
  MainLayoutIndexRoute: typeof MainLayoutIndexRoute
  MainLayoutBalanceIndexRoute: typeof MainLayoutBalanceIndexRoute
  MainLayoutBuyIndexRoute: typeof MainLayoutBuyIndexRoute
  MainLayoutClaimIndexRoute: typeof MainLayoutClaimIndexRoute
  MainLayoutCurrentmonthIndexRoute: typeof MainLayoutCurrentmonthIndexRoute
  MainLayoutInvestIndexRoute: typeof MainLayoutInvestIndexRoute
  MainLayoutWalletIndexRoute: typeof MainLayoutWalletIndexRoute
  MainLayoutWalletDepositIndexRoute: typeof MainLayoutWalletDepositIndexRoute
  MainLayoutWalletPaymentProcessIndexRoute: typeof MainLayoutWalletPaymentProcessIndexRoute
  MainLayoutWalletSwapIndexRoute: typeof MainLayoutWalletSwapIndexRoute
  MainLayoutWalletTransactionErrorIndexRoute: typeof MainLayoutWalletTransactionErrorIndexRoute
  MainLayoutWalletTransactionSuccessIndexRoute: typeof MainLayoutWalletTransactionSuccessIndexRoute
  MainLayoutWalletWaitIndexRoute: typeof MainLayoutWalletWaitIndexRoute
  MainLayoutWalletWithdrawIndexRoute: typeof MainLayoutWalletWithdrawIndexRoute
  MainLayoutWalletSwapWaitIndexRoute: typeof MainLayoutWalletSwapWaitIndexRoute
  MainLayoutWalletWaitDepositIndexRoute: typeof MainLayoutWalletWaitDepositIndexRoute
  MainLayoutInvestCodeYearMonthIndexRoute: typeof MainLayoutInvestCodeYearMonthIndexRoute
  MainLayoutInvestStatsCodeYearMonthIndexRoute: typeof MainLayoutInvestStatsCodeYearMonthIndexRoute
  MainLayoutWalletSwapDepositIdmKeyIndexRoute: typeof MainLayoutWalletSwapDepositIdmKeyIndexRoute
}

const MainLayoutRouteChildren: MainLayoutRouteChildren = {
  MainLayoutProfileRoute: MainLayoutProfileRouteWithChildren,
  MainLayoutIndexRoute: MainLayoutIndexRoute,
  MainLayoutBalanceIndexRoute: MainLayoutBalanceIndexRoute,
  MainLayoutBuyIndexRoute: MainLayoutBuyIndexRoute,
  MainLayoutClaimIndexRoute: MainLayoutClaimIndexRoute,
  MainLayoutCurrentmonthIndexRoute: MainLayoutCurrentmonthIndexRoute,
  MainLayoutInvestIndexRoute: MainLayoutInvestIndexRoute,
  MainLayoutWalletIndexRoute: MainLayoutWalletIndexRoute,
  MainLayoutWalletDepositIndexRoute: MainLayoutWalletDepositIndexRoute,
  MainLayoutWalletPaymentProcessIndexRoute:
    MainLayoutWalletPaymentProcessIndexRoute,
  MainLayoutWalletSwapIndexRoute: MainLayoutWalletSwapIndexRoute,
  MainLayoutWalletTransactionErrorIndexRoute:
    MainLayoutWalletTransactionErrorIndexRoute,
  MainLayoutWalletTransactionSuccessIndexRoute:
    MainLayoutWalletTransactionSuccessIndexRoute,
  MainLayoutWalletWaitIndexRoute: MainLayoutWalletWaitIndexRoute,
  MainLayoutWalletWithdrawIndexRoute: MainLayoutWalletWithdrawIndexRoute,
  MainLayoutWalletSwapWaitIndexRoute: MainLayoutWalletSwapWaitIndexRoute,
  MainLayoutWalletWaitDepositIndexRoute: MainLayoutWalletWaitDepositIndexRoute,
  MainLayoutInvestCodeYearMonthIndexRoute:
    MainLayoutInvestCodeYearMonthIndexRoute,
  MainLayoutInvestStatsCodeYearMonthIndexRoute:
    MainLayoutInvestStatsCodeYearMonthIndexRoute,
  MainLayoutWalletSwapDepositIdmKeyIndexRoute:
    MainLayoutWalletSwapDepositIdmKeyIndexRoute,
}

const MainLayoutRouteWithChildren = MainLayoutRoute._addFileChildren(
  MainLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof MainLayoutRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/profile': typeof MainLayoutProfileRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRoute
  '/': typeof MainLayoutIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/balance': typeof MainLayoutBalanceIndexRoute
  '/buy': typeof MainLayoutBuyIndexRoute
  '/claim': typeof MainLayoutClaimIndexRoute
  '/current_month': typeof MainLayoutCurrentmonthIndexRoute
  '/invest': typeof MainLayoutInvestIndexRoute
  '/profile/': typeof MainLayoutProfileIndexRoute
  '/wallet': typeof MainLayoutWalletIndexRoute
  '/profile/account': typeof MainLayoutProfileAccountIndexRoute
  '/profile/mobileMenu': typeof MainLayoutProfileMobileMenuIndexRoute
  '/profile/notification': typeof MainLayoutProfileNotificationIndexRoute
  '/profile/quest': typeof MainLayoutProfileQuestIndexRoute
  '/profile/referral': typeof MainLayoutProfileReferralIndexRoute
  '/profile/safety': typeof MainLayoutProfileSafetyIndexRoute
  '/wallet/deposit': typeof MainLayoutWalletDepositIndexRoute
  '/wallet/payment-process': typeof MainLayoutWalletPaymentProcessIndexRoute
  '/wallet/swap': typeof MainLayoutWalletSwapIndexRoute
  '/wallet/transaction-error': typeof MainLayoutWalletTransactionErrorIndexRoute
  '/wallet/transaction-success': typeof MainLayoutWalletTransactionSuccessIndexRoute
  '/wallet/wait': typeof MainLayoutWalletWaitIndexRoute
  '/wallet/withdraw': typeof MainLayoutWalletWithdrawIndexRoute
  '/wallet/swap/wait': typeof MainLayoutWalletSwapWaitIndexRoute
  '/wallet/wait/deposit': typeof MainLayoutWalletWaitDepositIndexRoute
  '/invest/$code/$year/$month': typeof MainLayoutInvestCodeYearMonthIndexRoute
  '/investStats/$code/$year/$month': typeof MainLayoutInvestStatsCodeYearMonthIndexRoute
  '/wallet/swap/deposit/$idmKey': typeof MainLayoutWalletSwapDepositIdmKeyIndexRoute
}

export interface FileRoutesByTo {
  '/auth/sign-in': typeof AuthSignInRoute
  '/': typeof MainLayoutIndexRoute
  '/auth': typeof AuthIndexRoute
  '/balance': typeof MainLayoutBalanceIndexRoute
  '/buy': typeof MainLayoutBuyIndexRoute
  '/claim': typeof MainLayoutClaimIndexRoute
  '/current_month': typeof MainLayoutCurrentmonthIndexRoute
  '/invest': typeof MainLayoutInvestIndexRoute
  '/profile': typeof MainLayoutProfileIndexRoute
  '/wallet': typeof MainLayoutWalletIndexRoute
  '/profile/account': typeof MainLayoutProfileAccountIndexRoute
  '/profile/mobileMenu': typeof MainLayoutProfileMobileMenuIndexRoute
  '/profile/notification': typeof MainLayoutProfileNotificationIndexRoute
  '/profile/quest': typeof MainLayoutProfileQuestIndexRoute
  '/profile/referral': typeof MainLayoutProfileReferralIndexRoute
  '/profile/safety': typeof MainLayoutProfileSafetyIndexRoute
  '/wallet/deposit': typeof MainLayoutWalletDepositIndexRoute
  '/wallet/payment-process': typeof MainLayoutWalletPaymentProcessIndexRoute
  '/wallet/swap': typeof MainLayoutWalletSwapIndexRoute
  '/wallet/transaction-error': typeof MainLayoutWalletTransactionErrorIndexRoute
  '/wallet/transaction-success': typeof MainLayoutWalletTransactionSuccessIndexRoute
  '/wallet/wait': typeof MainLayoutWalletWaitIndexRoute
  '/wallet/withdraw': typeof MainLayoutWalletWithdrawIndexRoute
  '/wallet/swap/wait': typeof MainLayoutWalletSwapWaitIndexRoute
  '/wallet/wait/deposit': typeof MainLayoutWalletWaitDepositIndexRoute
  '/invest/$code/$year/$month': typeof MainLayoutInvestCodeYearMonthIndexRoute
  '/investStats/$code/$year/$month': typeof MainLayoutInvestStatsCodeYearMonthIndexRoute
  '/wallet/swap/deposit/$idmKey': typeof MainLayoutWalletSwapDepositIdmKeyIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_mainLayout': typeof MainLayoutRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/_mainLayout/profile': typeof MainLayoutProfileRouteWithChildren
  '/auth/sign-in': typeof AuthSignInRoute
  '/_mainLayout/': typeof MainLayoutIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/_mainLayout/balance/': typeof MainLayoutBalanceIndexRoute
  '/_mainLayout/buy/': typeof MainLayoutBuyIndexRoute
  '/_mainLayout/claim/': typeof MainLayoutClaimIndexRoute
  '/_mainLayout/current_month/': typeof MainLayoutCurrentmonthIndexRoute
  '/_mainLayout/invest/': typeof MainLayoutInvestIndexRoute
  '/_mainLayout/profile/': typeof MainLayoutProfileIndexRoute
  '/_mainLayout/wallet/': typeof MainLayoutWalletIndexRoute
  '/_mainLayout/profile/account/': typeof MainLayoutProfileAccountIndexRoute
  '/_mainLayout/profile/mobileMenu/': typeof MainLayoutProfileMobileMenuIndexRoute
  '/_mainLayout/profile/notification/': typeof MainLayoutProfileNotificationIndexRoute
  '/_mainLayout/profile/quest/': typeof MainLayoutProfileQuestIndexRoute
  '/_mainLayout/profile/referral/': typeof MainLayoutProfileReferralIndexRoute
  '/_mainLayout/profile/safety/': typeof MainLayoutProfileSafetyIndexRoute
  '/_mainLayout/wallet/deposit/': typeof MainLayoutWalletDepositIndexRoute
  '/_mainLayout/wallet/payment-process/': typeof MainLayoutWalletPaymentProcessIndexRoute
  '/_mainLayout/wallet/swap/': typeof MainLayoutWalletSwapIndexRoute
  '/_mainLayout/wallet/transaction-error/': typeof MainLayoutWalletTransactionErrorIndexRoute
  '/_mainLayout/wallet/transaction-success/': typeof MainLayoutWalletTransactionSuccessIndexRoute
  '/_mainLayout/wallet/wait/': typeof MainLayoutWalletWaitIndexRoute
  '/_mainLayout/wallet/withdraw/': typeof MainLayoutWalletWithdrawIndexRoute
  '/_mainLayout/wallet/swap/wait/': typeof MainLayoutWalletSwapWaitIndexRoute
  '/_mainLayout/wallet/wait/deposit/': typeof MainLayoutWalletWaitDepositIndexRoute
  '/_mainLayout/invest/$code/$year/$month/': typeof MainLayoutInvestCodeYearMonthIndexRoute
  '/_mainLayout/investStats/$code/$year/$month/': typeof MainLayoutInvestStatsCodeYearMonthIndexRoute
  '/_mainLayout/wallet/swap/deposit/$idmKey/': typeof MainLayoutWalletSwapDepositIdmKeyIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/auth'
    | '/profile'
    | '/auth/sign-in'
    | '/'
    | '/auth/'
    | '/balance'
    | '/buy'
    | '/claim'
    | '/current_month'
    | '/invest'
    | '/profile/'
    | '/wallet'
    | '/profile/account'
    | '/profile/mobileMenu'
    | '/profile/notification'
    | '/profile/quest'
    | '/profile/referral'
    | '/profile/safety'
    | '/wallet/deposit'
    | '/wallet/payment-process'
    | '/wallet/swap'
    | '/wallet/transaction-error'
    | '/wallet/transaction-success'
    | '/wallet/wait'
    | '/wallet/withdraw'
    | '/wallet/swap/wait'
    | '/wallet/wait/deposit'
    | '/invest/$code/$year/$month'
    | '/investStats/$code/$year/$month'
    | '/wallet/swap/deposit/$idmKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth/sign-in'
    | '/'
    | '/auth'
    | '/balance'
    | '/buy'
    | '/claim'
    | '/current_month'
    | '/invest'
    | '/profile'
    | '/wallet'
    | '/profile/account'
    | '/profile/mobileMenu'
    | '/profile/notification'
    | '/profile/quest'
    | '/profile/referral'
    | '/profile/safety'
    | '/wallet/deposit'
    | '/wallet/payment-process'
    | '/wallet/swap'
    | '/wallet/transaction-error'
    | '/wallet/transaction-success'
    | '/wallet/wait'
    | '/wallet/withdraw'
    | '/wallet/swap/wait'
    | '/wallet/wait/deposit'
    | '/invest/$code/$year/$month'
    | '/investStats/$code/$year/$month'
    | '/wallet/swap/deposit/$idmKey'
  id:
    | '__root__'
    | '/_mainLayout'
    | '/auth'
    | '/_mainLayout/profile'
    | '/auth/sign-in'
    | '/_mainLayout/'
    | '/auth/'
    | '/_mainLayout/balance/'
    | '/_mainLayout/buy/'
    | '/_mainLayout/claim/'
    | '/_mainLayout/current_month/'
    | '/_mainLayout/invest/'
    | '/_mainLayout/profile/'
    | '/_mainLayout/wallet/'
    | '/_mainLayout/profile/account/'
    | '/_mainLayout/profile/mobileMenu/'
    | '/_mainLayout/profile/notification/'
    | '/_mainLayout/profile/quest/'
    | '/_mainLayout/profile/referral/'
    | '/_mainLayout/profile/safety/'
    | '/_mainLayout/wallet/deposit/'
    | '/_mainLayout/wallet/payment-process/'
    | '/_mainLayout/wallet/swap/'
    | '/_mainLayout/wallet/transaction-error/'
    | '/_mainLayout/wallet/transaction-success/'
    | '/_mainLayout/wallet/wait/'
    | '/_mainLayout/wallet/withdraw/'
    | '/_mainLayout/wallet/swap/wait/'
    | '/_mainLayout/wallet/wait/deposit/'
    | '/_mainLayout/invest/$code/$year/$month/'
    | '/_mainLayout/investStats/$code/$year/$month/'
    | '/_mainLayout/wallet/swap/deposit/$idmKey/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  MainLayoutRoute: typeof MainLayoutRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  MainLayoutRoute: MainLayoutRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_mainLayout",
        "/auth"
      ]
    },
    "/_mainLayout": {
      "filePath": "_mainLayout.tsx",
      "children": [
        "/_mainLayout/profile",
        "/_mainLayout/",
        "/_mainLayout/balance/",
        "/_mainLayout/buy/",
        "/_mainLayout/claim/",
        "/_mainLayout/current_month/",
        "/_mainLayout/invest/",
        "/_mainLayout/wallet/",
        "/_mainLayout/wallet/deposit/",
        "/_mainLayout/wallet/payment-process/",
        "/_mainLayout/wallet/swap/",
        "/_mainLayout/wallet/transaction-error/",
        "/_mainLayout/wallet/transaction-success/",
        "/_mainLayout/wallet/wait/",
        "/_mainLayout/wallet/withdraw/",
        "/_mainLayout/wallet/swap/wait/",
        "/_mainLayout/wallet/wait/deposit/",
        "/_mainLayout/invest/$code/$year/$month/",
        "/_mainLayout/investStats/$code/$year/$month/",
        "/_mainLayout/wallet/swap/deposit/$idmKey/"
      ]
    },
    "/auth": {
      "filePath": "auth.tsx",
      "children": [
        "/auth/sign-in",
        "/auth/"
      ]
    },
    "/_mainLayout/profile": {
      "filePath": "_mainLayout/profile.tsx",
      "parent": "/_mainLayout",
      "children": [
        "/_mainLayout/profile/",
        "/_mainLayout/profile/account/",
        "/_mainLayout/profile/mobileMenu/",
        "/_mainLayout/profile/notification/",
        "/_mainLayout/profile/quest/",
        "/_mainLayout/profile/referral/",
        "/_mainLayout/profile/safety/"
      ]
    },
    "/auth/sign-in": {
      "filePath": "auth/sign-in.tsx",
      "parent": "/auth"
    },
    "/_mainLayout/": {
      "filePath": "_mainLayout/index.tsx",
      "parent": "/_mainLayout"
    },
    "/auth/": {
      "filePath": "auth/index.tsx",
      "parent": "/auth"
    },
    "/_mainLayout/balance/": {
      "filePath": "_mainLayout/balance/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/buy/": {
      "filePath": "_mainLayout/buy/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/claim/": {
      "filePath": "_mainLayout/claim/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/current_month/": {
      "filePath": "_mainLayout/current_month/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/invest/": {
      "filePath": "_mainLayout/invest/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/profile/": {
      "filePath": "_mainLayout/profile/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/wallet/": {
      "filePath": "_mainLayout/wallet/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/profile/account/": {
      "filePath": "_mainLayout/profile/account/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/mobileMenu/": {
      "filePath": "_mainLayout/profile/mobileMenu/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/notification/": {
      "filePath": "_mainLayout/profile/notification/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/quest/": {
      "filePath": "_mainLayout/profile/quest/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/referral/": {
      "filePath": "_mainLayout/profile/referral/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/profile/safety/": {
      "filePath": "_mainLayout/profile/safety/index.tsx",
      "parent": "/_mainLayout/profile"
    },
    "/_mainLayout/wallet/deposit/": {
      "filePath": "_mainLayout/wallet/deposit/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/payment-process/": {
      "filePath": "_mainLayout/wallet/payment-process/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/swap/": {
      "filePath": "_mainLayout/wallet/swap/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/transaction-error/": {
      "filePath": "_mainLayout/wallet/transaction-error/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/transaction-success/": {
      "filePath": "_mainLayout/wallet/transaction-success/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/wait/": {
      "filePath": "_mainLayout/wallet/wait/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/withdraw/": {
      "filePath": "_mainLayout/wallet/withdraw/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/swap/wait/": {
      "filePath": "_mainLayout/wallet/swap/wait/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/wait/deposit/": {
      "filePath": "_mainLayout/wallet/wait/deposit/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/invest/$code/$year/$month/": {
      "filePath": "_mainLayout/invest/$code/$year/$month/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/investStats/$code/$year/$month/": {
      "filePath": "_mainLayout/investStats/$code/$year/$month/index.tsx",
      "parent": "/_mainLayout"
    },
    "/_mainLayout/wallet/swap/deposit/$idmKey/": {
      "filePath": "_mainLayout/wallet/swap/deposit/$idmKey/index.tsx",
      "parent": "/_mainLayout"
    }
  }
}
ROUTE_MANIFEST_END */
